module.exports = "<aside class=\"control-sidebar control-sidebar-dark\">  \r\n  <div class=\"tab-content\">\r\n    <div class=\"tab-pane\" id=\"control-sidebar-stats-tab\">Stats Tab Content</div>\r\n  </div>\r\n  <div class=\"control-sidebar-bg\"></div>\r\n</aside>\r\n<div class=\"control-sidebar-bg\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/layout/components/control-sidebar/control-sidebar.component.html
// module id = ./src/app/containers/layout/components/control-sidebar/control-sidebar.component.html
// module chunks = main